export enum CheckoutSessionCode {
  CHECKOUT_INVALID_TICKET_TYPE = 1,
  CHECKOUT_INVALID_TICKET_TYPE_QTY = 2,
  CHECKOUT_INVALID_TICKET_TYPE_SEAT = 3,
  CHECKOUT_ORDER_CREATED = 4,
  CHECKOUT_ORDER_ACTIVE = 5,
  CHECKOUT_SESSION_CREATED = 6,
}
